import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const RadioBox = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { label , ...props } = param;
    return /*#__PURE__*/ _jsxs("label", {
        className: "cursor-pointer rounded-md py-4 px-2 flex flex-col items-center justify-center gap-3 border border-gray-200 bg-white group hover:bg-gray-300/20 has-[:checked]:bg-indigo-0 has-[:checked]:border-primary-main",
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "radio",
                className: "sr-only peer",
                ...props,
                ref: ref
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-4 h-4 rounded-full border-2 border-gray-200 flex items-center justify-center group-has-[:checked]:bg-primary-main group-has-[:checked]:border-primary-main group-hover:bg-white",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "w-1.5 h-1.5 rounded-full bg-white opacity-0 group-has-[:checked]:opacity-100"
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "text-center",
                children: label
            })
        ]
    });
});
RadioBox.displayName = "RadioBox";
export default RadioBox;
